// Inspection form definitions per PRD.
// Single source of truth — consumed by InspectScreen (the tech form) and the
// admin Highgrove onboarding analytics (funnel over the onboarding steps).
export const INSPECTION_TYPES = {
  fire: {
    label: 'Fire Safety',
    items: [
      { id: 'smoke_detectors', label: 'Smoke Detectors', options: ['working', 'not working', 'missing'] },
      { id: 'co_detectors', label: 'CO Detectors', options: ['working', 'not working', 'missing'] },
      { id: 'fire_extinguisher', label: 'Fire Extinguisher', options: ['present', 'missing', 'expired'] },
      { id: 'egress_windows', label: 'Egress Windows', options: ['clear', 'blocked'] },
      { id: 'electrical_hazards', label: 'Electrical Hazards', options: ['none', 'identified'] },
      { id: 'extension_cord_misuse', label: 'Extension Cord Misuse', options: ['none', 'identified'] },
      { id: 'dryer_vent', label: 'Dryer Vent', options: ['clear', 'blocked'] },
      { id: 'stove_oven', label: 'Stove/Oven Condition', options: ['good', 'needs attention'] },
      { id: 'water_heater_clearance', label: 'Water Heater Clearance', options: ['yes', 'no'] },
    ],
  },
  moveout: {
    label: 'Move-out',
    items: [
      { id: 'cleanliness', label: 'Overall Cleanliness', options: ['1', '2', '3', '4', '5'], type: 'scale' },
      { id: 'walls', label: 'Walls Condition', options: ['good', 'holes', 'marks', 'damage'] },
      { id: 'flooring', label: 'Flooring Condition', options: ['good', 'scratched', 'stained', 'damaged'] },
      { id: 'kitchen_appliances', label: 'Kitchen Appliances', options: ['working', 'needs repair', 'missing'] },
      { id: 'bathroom_fixtures', label: 'Bathroom Fixtures', options: ['good', 'needs repair'] },
      { id: 'windows', label: 'Windows', options: ['good', 'cracked', 'broken'] },
      { id: 'doors', label: 'Doors', options: ['good', 'damaged', 'missing hardware'] },
      { id: 'blinds', label: 'Blinds/Window Coverings', options: ['good', 'damaged', 'missing'] },
      { id: 'light_fixtures', label: 'Light Fixtures', options: ['all working', 'some out', 'damaged'] },
      { id: 'hvac_filter', label: 'HVAC Filter', options: ['clean', 'dirty', 'missing'] },
      { id: 'keys_returned', label: 'Keys Returned', options: ['yes', 'no'] },
      { id: 'forwarding_address', label: 'Forwarding Address Collected', options: ['yes', 'no'] },
    ],
  },
  onboarding: {
    label: 'Highgrove Onboarding',
    format: 'checklist',
    sections: [
      {
        id: 'greet',
        title: 'Greet Tenants',
        steps: [
          { id: 'greet_each', title: 'Greet each tenant', detail: 'Explain what SNSHN is doing, our SNSHN Standard, and ask if they have any questions or urgent issues. Explain the work order process. This should take no more than 2-3 minutes a tenant.' },
          { id: 'no_tenant', title: 'No Tenant Home', detail: 'If tenant is not available, mark as such in system and let support staff know so we can reschedule.' },
        ],
      },
      {
        id: 'locks',
        title: 'Lock Change',
        steps: [
          { id: 'replace_locks', title: 'Replace Unit locks', detail: 'Replace unit locks and enter the lock information into the trades app.', lockForm: true, noNote: true },
          { id: 'hand_keys', title: 'Hand keys to tenants', detail: 'Explain the key situation, common keys, and how they get replacement keys if needed.' },
        ],
      },
      {
        id: 'inspection',
        title: 'Property Inspection',
        steps: [
          { id: 'inspect_units', title: 'Inspect each unit quickly', detail: 'Quickly walk through each unit, verify no critical issues (plumbing leaks, roof leaks, major safety hazards), and document any major issues.', noNote: true, workOrder: { url: 'https://sunshinemgmt.appfolio.com/maintenance/service_requests/new', assignee: 'Brandon' } },
          { id: 'detectors', title: 'Install new Smoke and Carbon Monoxide Detectors', detail: 'Install new smoke and carbon monoxide detectors in all required areas. Document the install count.', photo: true },
          { id: 'utility_room', title: 'Inspect basement/utility room', detail: 'Verify filter size, enter it into the system, and install new filters for furnaces/AC.', photo: true },
          { id: 'bait_traps', title: 'Install Bait Traps', detail: 'Install bait traps and spray for roaches as required. Inform tenant(s) of traps and treatments and how often they are checked.' },
        ],
      },
    ],
  },
};
